/*eslint-disable*/
import React, { useState } from 'react'
import {
    Button,
    Table,
    Tr,
    Flex,
    MainHeadline,
    PageWrapper,
    PageFooter,
    Th,
} from '../../styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { AppDispatch, RootState } from 'store'
import { setConfirmModal } from 'features/global/globalSlice'
import { Options } from 'components/Options/Options'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { getParams, handlePagination } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import { ModalTypes } from '../../types/global.interface'
import useQueryPagination from 'hooks/useQueryPagination'
import { clearCompanyAdmins, deleteCompanyAdmin, getCompanyAdmins } from 'features/companyAdmins/companyAdminsSlice'
import { CompanyAdminsModal, ICompanyAdminsModalState } from './CompanyAdminModal'
import { ICompanyAdminSingleResponse } from 'types/api/companyAdminsApi.interface'

export const CompanyAdmins: React.FC = () => {
    const { admins, totalPages } = useSelector((state: RootState) => state.companyAdmins)
    const dispatch = useDispatch<AppDispatch>()
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const [modal, setModal] = useState({ open: false, value: null })

    useQueryPagination({ fetchFunctions: [getCompanyAdmins], cleanUpFunctions: [clearCompanyAdmins], params })

    const removeItem = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteCompanyAdmin(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: admins.length < 2,
                },
                word: 'delete company administrator',
            }),
        )
    }

    const getModalValues = (item: ICompanyAdminSingleResponse): ICompanyAdminsModalState => {
        return {
            ...item,
            company: { value: item.info.company.id, label: item.info.company.name },
        }
    }

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between center mb='16' >
                    <MainHeadline>Company Administrators</MainHeadline>
                    <Button orange onClick={() => setModal({ value: null, open: true })}>
                        Add Administrator
                    </Button>
                </Flex>
                {!admins?.length ? (
                    <NoItems title='Company Administrators' />
                ) : (
                    <Table>
                        <Th>
                            <Td w='15%' noTooltip text='FIRST NAME' />
                            <Td w='15%' noTooltip text='LAST NAME' />
                            <Td w='15%' noTooltip text='USERNAME' />
                            <Td w='15%' noTooltip text='EMAIL' />
                            <Td w='15%' noTooltip text='PHONE NUMBER' />
                            <Td w='20%' noTooltip text='COMPANY NAME' />
                            <Td w='5%' />
                        </Th>
                        {admins.map((item) => {
                            return (
                                <Tr key={item.id}>
                                    <Td w='15%' text={item?.firstName} />
                                    <Td w='15%' text={item?.lastName} />
                                    <Td w='15%' text={item?.username} />
                                    <Td w='15%' text={item?.email} />
                                    <Td w='15%' text={item?.phoneNumber} />
                                    <Td w='20%' text={item?.info?.company?.name} />
                                    <Td options w='5%'>
                                        <Options openModal={() => setModal({ open: true, value: getModalValues(item) })} item={item} title='Company Admin' handleRemove={removeItem} />
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Table>
                )}
                {modal.open && <CompanyAdminsModal value={modal.value} closeModal={() => setModal({ value: null, open: false })} />}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
